import React, { useState, useEffect } from "react";
import { DOC_CENTER } from "@/constants/testIds";
import { ArrowUpRight } from "lucide-react";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid={DOC_CENTER.nav.container}
      className={`sticky top-0 z-50 w-full transition-colors duration-200 ${
        scrolled ? "dc-glass border-b border-[color:var(--dc-border)]" : "bg-transparent"
      }`}
    >
      <div className="dc-container flex h-16 items-center justify-between gap-4">
        <a href="#top" data-testid={DOC_CENTER.nav.logo} className="flex min-w-0 items-baseline gap-1.5 leading-none">
          <span className="truncate font-display text-[15px] font-extrabold tracking-tight text-ink-950">
            DeMaxtore
          </span>
          <span className="shrink-0 font-mono text-[10px] uppercase tracking-[0.18em] text-ink-500">
            /docs
          </span>
        </a>

        <nav className="hidden items-center gap-8 md:flex">
          <a data-testid={DOC_CENTER.nav.linkProduct} href="#why" className="text-sm font-medium text-ink-600 transition-colors hover:text-ink-950">
            Product
          </a>
          <a data-testid={DOC_CENTER.nav.linkWorkspace} href="#workspace" className="text-sm font-medium text-ink-600 transition-colors hover:text-ink-950">
            Workspace
          </a>
          <a data-testid={DOC_CENTER.nav.linkFAQ} href="#faq" className="text-sm font-medium text-ink-600 transition-colors hover:text-ink-950">
            FAQ
          </a>
        </nav>

        <div className="flex shrink-0 items-center gap-2">
          <a data-testid={DOC_CENTER.nav.ctaOpen} href="#hero" className="dc-btn-primary !px-3 !py-2 sm:!px-4">
            <span className="hidden sm:inline">Open Document Center</span>
            <span className="sm:hidden">Open</span>
            <ArrowUpRight className="h-4 w-4" strokeWidth={1.75} />
          </a>
        </div>
      </div>
    </header>
  );
}
